import { boolean, object, string } from "yup";

import "./schemas";

const disposalSiteSchema = object({
  name: string().trim().required(),
  latitude: string().trim().validLatitude().label("Latitude"),
  longitude: string().trim().validLongitude().label("Longitude"),
  active: boolean()
});

export default disposalSiteSchema;
